export const LOCAL_STORAGE_SESSION_TOKEN_KEY = 'sessionToken'
export const LOCAL_STORAGE_SESSION_TOKEN_EXPIRES_AT_KEY = 'sessionTokenExpiresAt'
export const HTTP_HEADER_SESSION_TOKEN_KEY = 'X-Session-Token'
export const HTTP_HEADER_MALL_ID_KEY = 'X-Mall-Id'
export const HTTP_HEADER_MALL_SLUG_KEY = 'X-Mall-Slug'

/**
 * Stamp Collection (API #1-8) khai báo `Accept-Language: en|kh`; BE dùng header này
 * để localize `name` / `description` / `mallName`... trong response.
 *
 * ✅ ĐÃ CHỐT: FE gửi `Accept-Language: en` cho **toàn bộ** API Stamp Collection (kể cả
 * #9-23 không khai báo header) — API nào không dùng localization thì tự bỏ qua header,
 * không gây lỗi.
 *
 * Admin Portal hiện chỉ render tiếng Anh (template dùng `.en` trực tiếp, không có
 * `translate.use()` ở đâu trong repo) nên cố định `en`. Khi bật đa ngữ cho Admin thì
 * thay giá trị này bằng ngôn ngữ đang chọn.
 */
export const HTTP_HEADER_ACCEPT_LANGUAGE_KEY = 'Accept-Language'
export const DEFAULT_ACCEPT_LANGUAGE = 'en'

/** Client-side session TTL: Remember me = 30 days, otherwise = 2 hours */
export const SESSION_TOKEN_TTL_MS = {
  REMEMBER_ME: 30 * 24 * 60 * 60 * 1000,
  DEFAULT: 2 * 60 * 60 * 1000,
}

export const STYLE_FILL_COLOR = 'fillColor'